import HeroSection from '../../components/LocationPages/HeroSection';
import MiddleSection from '../../components/LocationPages/MiddleSection';

const data = {
  seo: {
    title: 'Financial Planning Experts in Mohali | PFGS India Office',
    description:
      'Financial planning, investment and wealth management advice from the PFGS India office in Mohali, Punjab.',
    canonical: 'https://pfgs.com.au/location-mohali',
  },
  heroTitle: 'Your Local Financial Planning Experts in Mohali',
  heroDescription: 'SCF 3, Industrial Area, Phase 1, Mohali, Punjab, India',
  location: 'Mohali',
  mainTitle: 'Personalised Financial Advice for a Stronger Financial Future',
  introText: [
    'At PFGS, we proudly help individuals, families, and businesses across Industrial Area, Phase 1, Mohali make smarter financial decisions. Whether you’re planning for retirement, managing business finances, investing for growth, or securing your family’s future — our Mohali financial advisors provide expert, transparent, and tailored guidance every step of the way.',
    'We understand the financial goals and challenges faced by residents and professionals in Mohali’s thriving industrial and business community. That’s why our approach is built on local insight, trust, and a commitment to helping you build long-term financial stability.',
  ],
  whyChooseTitle: 'Why Choose PFGS as Your Mohali Financial Advisor?',
  reasons: [
    {
      title: 'Local Understanding:',
      description: 'We know the Mohali market — from real estate trends to business growth opportunities — and tailor strategies accordingly.',
    },
    {
      title: 'Comprehensive Financial Planning:',
      description: 'Covering budgeting, superannuation/retirement, insurance, investments, and debt management — all under one roof.',
    },
    {
      title: 'Transparent Advice:',
      description: 'No product push or hidden agenda — only independent, practical financial solutions designed for you..',
    },
    {
      title: 'Continuous Support:',
      description: 'We regularly review and refine your financial plan to keep you on track toward your goals.',
    },
    {
      title: 'Goal-Focused Strategies:',
      description: 'Every client’s journey is different, so we design strategies that fit your personal and business objectives.',
    },
  ],
  servicesTitle: 'Our Financial Services in Mohali',
  services: [
    {
      title: '1. Financial Planning',
      description:
        'Our experts help you set realistic goals, streamline your finances, and create a roadmap that drives long-term growth and peace of mind.',
      bullets: [],
    },
    {
      title: '2. Investment Strategy & Wealth Building',
      description: 'Get professional advice on creating diversified portfolios that balance opportunity and risk for steady, sustainable returns.',
    },
    {
      title: '3. Retirement Planning & Superannuation',
      description: 'Secure your future with a plan that helps you build and manage your retirement savings effectively.',
    },
    {
      title: '4. Insurance & Risk Protection',
      description: 'ife is unpredictable — our advisors ensure your family, income, and assets are safeguarded with the right insurance coverage.',
    },
    {
      title: '5. Debt Strategy & Cash Flow Management',
      description: 'We help you reduce debt efficiently, improve budgeting, and maintain financial flexibility for personal and business needs.',
    },
  ],
  whoWeHelpTitle: 'Who We Help',
  whoWeHelp: [
    {
      title: 'Professionals & Families:',
      description: 'Balancing lifestyle aspirations with long-term financial stability.',
    },
    {
      title: 'Entrepreneurs & Business Owners:',
      description: 'Managing finances, taxes, and investments for business growth.',
    },
    {
      title: 'First-Time Property Investors:',
      description: 'Building wealth through informed and structured investment strategies.',
    },
    {
      title: 'Pre-Retirees & Retirees:',
      description: 'Planning for financial independence and post-retirement comfort.',
    },
  ],
  aboutTitle: 'About PFGS – Financial Planning in Mohali',
  aboutText: [
    'At PFGS, we believe financial advice should be simple, honest, and empowering. Our financial advisors in Mohali are dedicated to helping you make confident decisions that align with your goals. With our client-first approach and continuous support, we make sure your finances work as hard as you do.',
  ],
  ctaTitle: 'Start Building Your Financial Future Today',
  ctaText:
    "Take the first step toward financial peace of mind. Contact PFGS – Mohali's trusted financial advisors – today for a complimentary initial consultation.",
  sidebarTitle: 'Ready To Get Started?',
  sidebarText: 'Speak with one of our experienced financial advisors to discover your options and available opportunities in Mohali.',
};

const MohaliLocation = () => {
  return (
    <div>
      <HeroSection data={data} />
      <MiddleSection data={data} />
    </div>
  );
};

export default MohaliLocation;
